import { roomTypeEnumList } from '../../../components/AgGrid/enumLists'

const roomTypeValueGetter = (props) => {
  const { value } = props
  return roomTypeEnumList(value)
}

export default roomTypeValueGetter
